import { useEffect } from 'react';
import { AuthLoadingScreen } from '@/core/components/loading/AuthLoadingScreen';
import { AppRoutesConfig } from '@/core/components/routing/AppRoutesConfig';
import { useAppDebug } from '@/core/hooks/useAppDebug';
import { useAuthInitialization } from '@/core/auth/use-auth-initialization';
import { useI18nStore } from '@/core/i18n/stores/i18n-store';

/**
 * AppRoutes - Main Routing Component
 *
 * Handles authentication initialization and routing.
 * All authentication logic is encapsulated in useAuthInitialization hook.
 */
export const AppRoutes = () => {
  // Initialize authentication and handle all auth-related effects
  const { isLoading, isInitialized } = useAuthInitialization();

  // Initialize i18n on app start
  const initializeI18n = useI18nStore((state) => state.initialize);

  useEffect(() => {
    initializeI18n();
  }, [initializeI18n]);

  // Debug hook for development
  useAppDebug();

  // Show loading screen while initializing
  if (isLoading || !isInitialized) {
    return <AuthLoadingScreen />;
  }

  return <AppRoutesConfig />;
};
